'use client';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Colors } from '@lichtblick/theme';
import { getColor } from '../../../utils';
import { MTextIntro } from '../../MTextIntro';
import { MProductCardOptional, MProductItemList } from '../shared/Card';
import { Section } from '../shared/Section';
import { ContainerColumn, OptionalComponentsWrapper } from './SolarProductBundle.styles';
export const SolarProductBundle = ({ cta, productListItem1, productListItem2, productListItem3, productListItem4, productListItemOptional1, productListItemOptional2, textIntro, theme = 'faded-gray' })=>{
    const backgroundColor = theme === 'white' ? Colors.FadedGray : Colors.White;
    return /*#__PURE__*/ _jsx(Section, {
        backgroundColor: theme ? getColor(theme) : undefined,
        children: /*#__PURE__*/ _jsxs(ContainerColumn, {
            children: [
                textIntro && /*#__PURE__*/ _jsx(MTextIntro, {
                    ...textIntro?.[0]
                }),
                /*#__PURE__*/ _jsx(MProductItemList, {
                    backgroundColor: backgroundColor,
                    cta: cta,
                    items: [
                        productListItem1?.[0],
                        productListItem2?.[0],
                        productListItem3?.[0],
                        productListItem4?.[0]
                    ]
                }),
                /*#__PURE__*/ _jsxs(OptionalComponentsWrapper, {
                    children: [
                        productListItemOptional1?.[0] && /*#__PURE__*/ _jsx(MProductCardOptional, {
                            backgroundColor: backgroundColor,
                            item: productListItemOptional1?.[0]
                        }),
                        productListItemOptional2?.[0] && /*#__PURE__*/ _jsx(MProductCardOptional, {
                            backgroundColor: backgroundColor,
                            item: productListItemOptional2?.[0]
                        })
                    ]
                })
            ]
        })
    });
};

//# sourceMappingURL=SolarProductBundle.js.map